<script setup lang="ts">
import ServiceSettingList from "@/views/playground/planner/order-management/service-setting/ServiceSettingList.vue";
</script>

<template>
  <service-setting-list></service-setting-list>
</template>

<style scoped></style>
